import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import './App.css';

import Image1 from "./Image1.jpg";
import Image2 from "./Image2.jpg";
import Image3 from "./Image3.png";
import Image4 from "./Image4.jpg";
import Image5 from "./Image5.jpg";
import HomeTopClients from './HomeTopClients';
import Gallery from './Gallery';
import AboutUs from './AboutUs';
import Services from './Services';
import Contact from './Contact';

function App() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 1200,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: false,
    fade: true,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    arrows: false,
  };

  const scrollToSection = (sectionId) => {
    setMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const navItems = [
    { label: 'Home', id: 'home' },
    { label: 'About', id: 'about-us' },
    { label: 'Services', id: 'services' },
    { label: 'Gallery', id: 'gallery' },
    { label: 'Contact', id: 'contact-form' },
  ];

  return (
    <div>
      {/* ── Navbar ── */}
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
        <div className="navbar__inner">
          <div className="navbar__brand" onClick={() => scrollToSection('home')}>
            EURO<span>LIGHT</span>
          </div>

          <button
            className="navbar__toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle navigation"
          >
            <span className="navbar__toggle-bar" />
            <span className="navbar__toggle-bar" />
            <span className="navbar__toggle-bar" />
          </button>

          <div className={`navbar__links ${menuOpen ? 'navbar__links--open' : ''}`}>
            {navItems.map((item) => (
              <span
                key={item.id}
                className="navbar__link"
                onClick={() => scrollToSection(item.id)}
              >
                {item.label}
              </span>
            ))}
          </div>
        </div>
      </nav>

      {/* ── Hero ── */}
      <section id="home" className="hero">
        <div className="hero__overlay" />
        <div className="hero__content">
          <span className="hero__tag">Dubai · Since 2001</span>
          <h1 className="hero__title">
            Where Innovation<br />Meets <span>Illumination</span>
          </h1>
          <p className="hero__subtitle">
            Premium lighting solutions from Europe and beyond — designed
            to transform every space into a work of art.
          </p>
          <button className="hero__cta" onClick={() => scrollToSection('contact-form')}>
            Get In Touch →
          </button>
        </div>

        <Slider {...settings}>
          {[Image1, Image2, Image3, Image4, Image5].map((img, i) => (
            <div key={i} className="hero__slide">
              <img src={img} alt={`Eurolight project ${i + 1}`} className="hero__image" />
            </div>
          ))}
        </Slider>
      </section>

      {/* ── Page Sections ── */}
      <AboutUs />
      <Services />
      <Gallery />
      <Contact />
      <HomeTopClients />
    </div>
  );
}

export default App;